import CloseIcon from "@mui/icons-material/Close";

export default function AppDialogShell({ children, onClose }) {
  return (
    <div
      className="app-dialog-backdrop"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="app-dialog"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button
          type="button"
          className="app-dialog__close-btn"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <CloseIcon fontSize="small" />
        </button>
        {children}
      </div>
    </div>
  );
}
